import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
//cookies
import {get_cookies} from "../../../components/Cookies/Cookies";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));



const JcOnlineShopOrders = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [drno, setDrno] = useState('');
	const [refno, setRefno] = useState('');
	const [releaseId, setReleaseId] = useState('');
	const [name, setName] = useState('');
	const [shippingId, setShippingId] = useState('');
	const [filterId, setFilterId] = useState(1);

	const [shipping,setShipping] = useState([]); //pickup dropdown

	const [modalOpen, setModalOpen] = useState(false);

	const [downloadFlag, setDownloadFlag] = useState(false);

	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	const dataFilter = async () => {
		setDataLoaded(false);
        await axios.get(
			process.env.REACT_APP_API_URL+'table_jconlineshop', {
            params:{
				jc_u_idno:useridNo,
				date_from:format(dateRange.startDate, "yyyy-MM-dd"),
				date_to:format(dateRange.endDate, "yyyy-MM-dd"), 
				drno:drno,
				refno:refno,
				release_status:releaseId,
				name:name,
				shipping_id:shippingId,
            }
        }).then((res)=>{
			setPosts(res.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		})
		setDataLoaded(true);
    }

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/get_shipping_list', {
			params:{
				jc_user_id_no: useridNo,  //branchIdNo
			}
		}).then((res)=>{
			setShipping(res.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		});
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "date",
			label: "Date",
		},
		{
			name: "sono",
			label: "SO No",
		},
		{
			name: "ref_number",
			label: "Reference Number",
		},
		{
			name: "shipping",
			label: "Shipping",
		},
		{
			name: "amount",
			label: "Amount",			
			options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "status",
			label: "Status",
		},
		{
			name: "encoded_by",
			label: "Encoded By",
		},
		{
			name: "action",
			label: "Action",
			options: {
				download: false, //exclude this column in csv export
				customBodyRenderLite: (dataIndex) => {
					let release_status =  posts[dataIndex].release_status;
					let sono =  posts[dataIndex].sono;
					if(release_status === 1){
						return(
							<Grid container spacing={0}>
									<Grid item xs={12} sm={12} md={4} lg={12} xl={4} style={{marginBottom: "0.5em"}}>
										<NavLink to={"/sales/jconlineshop-view/"+sono+"/view"}>
											<Button variant="contained" color="primary">
												View
											</Button>	
										</NavLink> 
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={8}>
											<Button disabled={true} variant="contained" color="primary">
												Released
											</Button>	
									</Grid>
							</Grid>
							)
					}else{
						return(
						<Grid container spacing={1}>
							<Grid item xs={12} sm={12} md={4} lg={12} xl={4}>
								<NavLink to={"/sales/jconlineshop-view/"+sono+"/view"}>
									<Button variant="contained" color="primary">
										View
									</Button>	
								</NavLink> 
							</Grid>
						<Grid item xs={12} sm={12} md={12} lg={12} xl={8}>
						{get_cookies('can_process') == 1 ?
							<NavLink to={"/sales/jconlineshop-view/"+sono+"/release"}>
								<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
									Release Order
								</Button>	
							</NavLink> 
						:null}
						</Grid>
					</Grid>);
				   }		
				}
	 		},
		} 
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		download: false,  //add this
		print: false, //add this
		viewColumns :false,
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		downloadOptions: {
			filename : 'JcOnlineShopOrders.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	const filterList = [
		{
			id:1,
			description:"Search By Date"
		},
		{
			id:2,
			description:"Search By SO NO"
		},
		{
			id:3,
			description:"Search By Reference No"
		},
		{
			id:4,
			description:"Search By Name"
		},
		{
			id:5,
			description:"Search By Shipping"
		},
		{
			id:6,
			description:"Search By Release Status"
		},
	];

	const releaseList = [
		{
			id:1,
			description:"Not Released"
		},
		{
			id:2,
			description:"Released"
		},
	];
	const selectReleaseProps = {
		options: releaseList,
		getOptionLabel: (option) => option.description,
	};
	const selectFilterProps = {
		options: filterList,
		getOptionLabel: (option) => option.description,
	};

	const selectShippingProps = {
		options: shipping,
		getOptionLabel: (option) => option.description,
	};
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h2 className="header-title">Sales</h2>
					</NavLink>
					<Typography color="textPrimary">Jc Online Shop Orders</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
                        <Grid container spacing={1}>
							<Grid item xs={12} md={5} lg={3} xl={3}>
								<Autocomplete
											{...selectFilterProps}
											id="auto-complete-2"
											autoComplete
											includeInputInList
											defaultValue={filterList[0]}
											renderInput={(params) => (
												<TextField
													{...params}
													margin="normal"
													label="Select Filter"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													//console.log(newValue.description);
													setFilterId(newValue.id);
												}
								}}
								/>
							</Grid>
							{filterId === 1 ? (<Grid item xs={12} md={5} lg={3} xl={3}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
									style={{marginTop:"1rem"}}
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>) :(<></>)}

						
						{filterId === 2 ? (<Grid item xs={12} md={5} lg={3} xl={3}>
									<TextField
													id="outlined-required"
													label="SO Number..."
													variant="outlined"
													style={{marginTop:"1rem"}}
													fullWidth={true}
													className={classes.field}
													value={drno} //to avoid label overlapping bug
													onChange={(e)=>{setDrno(e.target.value)}}
													InputProps={{
														type: 'text',
													  }}
										/>
							</Grid>) : (<></>) }

							{filterId === 3 ? (<Grid item xs={12} md={5} lg={3} xl={3}>
									<TextField
													id="outlined-required"
													style={{marginTop:"1rem"}}
													label="Reference Number..."
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={refno} //to avoid label overlapping bug
													onChange={(e)=>{setRefno(e.target.value)}}
													InputProps={{
														type: 'text',
													  }}
										/>
							</Grid>) : (<></>) }

							{filterId === 4 ? (<Grid item xs={12} md={5} lg={3} xl={3}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
									style={{marginTop:"1rem"}}
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
							</Grid>) : (<></>) }

							{filterId === 4 ? (<Grid item xs={12} md={5} lg={3} xl={3}>
									<TextField
													id="outlined-required"
													label="Name..."
													style={{marginTop:"1rem"}}
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={name} //to avoid label overlapping bug
													onChange={(e)=>{setName(e.target.value)}}
													InputProps={{
														type: 'text',
													  }}
										/>
							</Grid>) : (<></>) }

							
							{filterId === 5 ? (<Grid item xs={12} md={5} lg={3} xl={3}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
									style={{marginTop:"1rem"}}
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
							</Grid>) : (<></>) }
							{filterId === 5 ? (<Grid item xs={12} md={5} lg={3} xl={3}>
								<Autocomplete
											{...selectShippingProps}
											id="auto-complete-2"
											autoComplete
											includeInputInList
											renderInput={(params) => (
												<TextField
													{...params}
													margin="normal"
													label="Select Shipping"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													//console.log(newValue.description);
													setShippingId(newValue.id);
												}
								}}
								/>
							</Grid>) : (<></>) }

														
							{filterId === 6 ? (<Grid item xs={12} md={5} lg={3} xl={3}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
									style={{marginTop:"1rem"}}
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
							</Grid>) : (<></>) }
							{filterId === 6 ? (<Grid item xs={12} md={5} lg={3} xl={3}>
								<Autocomplete
											{...selectReleaseProps}
											id="auto-complete-2"
											autoComplete
											includeInputInList
											renderInput={(params) => (
												<TextField
													{...params}
													margin="normal"
													label="Release Status"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													//console.log(newValue.description);
													setReleaseId(newValue.id);
												}
								}}
								/>
							</Grid>) : (<></>) }

                            <Grid item xs={1} lg={1} xl={1}>
                                <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                            </Grid>
                        </Grid>        
                    </div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					// <MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
									<h3 className="header-title" style ={{color: "#339933"}}>
									Jc Online Shop Orders
									</h3>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
				//   </MuiThemeProvider>
				)}
			</div>
		</div>
	);
};

export default JcOnlineShopOrders;